import type { Widget } from "../../core/types";
import { detectLocale } from "../../utils/localeUtil";
import storageService from "./storageService";
import { getErrorStatus } from "../utils/getErrorStatus";

export type WidgetResult =
  | { success: true; widget: Widget }
  | { success: false; status: number | undefined };

export const getWidgetById = async (
  apiUrl: string,
  token: string,
  widgetId: string,
  userEmail: string,
  signal: AbortSignal,
): Promise<WidgetResult> => {
  const url = new URL(`${apiUrl}/widgets/${widgetId}`);
  url.searchParams.set(
    "uuid",
    storageService.getContact(widgetId, "uuid") as string,
  );
  url.searchParams.set("email", userEmail);
  url.searchParams.set("lang", detectLocale() ?? "");

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal,
    });

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`, {
        cause: response.status,
      });
    }

    const widget = (await response.json()) as Widget;
    return { success: true, widget };
  } catch (error) {
    return { success: false, status: getErrorStatus(error) };
  }
};
